var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(_vm.type + "-channel", {
    tag: "component",
    staticClass: "channel-link",
    attrs: {
      color: _vm.color,
      background: _vm.background,
      subject: _vm.subject,
      link: _vm.link,
      text: _vm.text,
      a11y: _vm.a11y,
      filled: _vm.filled,
      poster: _vm.poster
    },
    nativeOn: {
      click: function($event) {
        return _vm.clickHandler($event)
      }
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }